export const users = [
  {
    'uuid': 'ec4de62a-cecc-40e8-b066-8a7297633d5c',
    'first_name': 'رضا',
    'last_name': 'کیانی',
    'phone': '989199620979',
    'birth_date': 768787200,
    'gender': 0
  },
  {
    'uuid': 'dc035d80-1d2d-4e78-85d7-b72a72f7cd76',
    'first_name': 'احمد',
    'last_name': 'سرابی',
    'phone': '989191111111',
    'birth_date': 969201804,
    'gender': 0
  },
  {
    'uuid': '651df9ab-6007-4265-950b-385231857b2b',
    'first_name': 'سید علی',
    'last_name': 'حسینی',
    'phone': '989192222222',
    'birth_date': 1284734604,
    'gender': 0
  },
  {
    'uuid': '2676361a-3113-4eb7-8fda-0231f8f5ca23',
    'first_name': 'مهدی',
    'last_name': 'طاهرپور کلانتری',
    'phone': '989193333333',
    'birth_date': 1379429004,
    'gender': 0
  }
]



// WEBPACK FOOTER //
// ./src/_helpers/backend-data/user.js